module.exports = __webpack_public_path__ + "img/60.10.pH.3fb650d3.png";